module.exports = __webpack_public_path__ + "static/media/23-6.ef9ecc8c.mp3";